import IndicatorBLock from '@/domain/scene/indicators/generic/IndicatorBlock.js'

const WIDTH_REL = 0.036
const HEIGHT_REL = 0.08

export default class ObserverIndicator extends IndicatorBLock {
  constructor (name, initXRel, initYRel) {
    super(
      name,
      WIDTH_REL,
      HEIGHT_REL,
      initXRel,
      initYRel
    )
  }

  getTextConfig () {
    return {
      x: -this.halfWidth,
      y: this.y + this.height * 0.08,
      width: this.width,
      text: this.text,
      lineHeight: 1.4,
      fill: 'white',
      fontSize: this.fontSize,
      align: 'center'
    }
  }
}
